import { CommonModule } from '@angular/common';
import { Component, Inject, inject, Input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  imports: [CommonModule, MatIconModule, ButtonComponent],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class AlertComponent {
  @Input() type: 'error' | 'success' | 'info' = 'info';
  @Input() text: string = '';
  @Input() icon: boolean = true;
  @Input() closeButton: boolean = false;
  @Input() button: string = '';
  @Input() url: string = '';
  snackBarRef = inject(MatSnackBarRef);

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private readonly router: Router
  ) {
    if (data) {
      this.text = data.text || this.text;
      this.icon = data.icon ? data.icon : this.icon;
      this.button = data.button || this.button;
      this.closeButton = data.closeButton || this.closeButton;
      this.url = data.url || this.url;
      this.type = data.type ? data.type : this.type;
    }
  }

  navigateToBasket() {
    this.router.navigate([this.url]);
    this.snackBarRef.dismiss();
  }

  closeSnackBar() {
    this.snackBarRef.dismiss();
  }
}
